export function obj2array(obj, addkey){
    
    if ( typeof(addkey) == "undefined") { addkey = false;  }

    
    var a =[];
    
    
    if($.isArray(obj)){
        return obj;
    }
    else if(obj!==undefined && obj!==null){
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
               if(addkey){
                   obj[key]['key'] = key
               }
               a.push(obj[key]);
            }
        }
    }
    
    return a;
}



export function isLocalStorageSupported(){
    if (typeof(Storage) !== "undefined") {

        // for ios safari, private mode, we need to actually try it.
        var testKey = 'test';
        try
        {
            localStorage.setItem(testKey, '1');
            localStorage.removeItem(testKey);
            return true;
        }
        catch (error)
        {
            return false;
        }
    }
    else{
        return false;
    }

} 



export function breakCamelCase(s){
    return s.replace(/([A-Z])/g, ' $1')                                 // insert a space before all caps
            .replace(/^./, function (str){return str.toUpperCase();});  // uppercase the first character
}


export function breakSnakeCase(s){
    return s.replace(/(_)/g, ' ')                                 // insert a space before all caps
            .replace(/^./, function (str){return str.toUpperCase();});  // uppercase the first character
}


export function arrayInterSection(a, b){
    return a.filter(function(n) {
        return b.indexOf(n) !== -1;
    })
} 


export function arrayUnion(a, b){
    var res = a.slice();
    for(var i=0; i<b.length; i++){
        var t = b[i];
        if(res.indexOf(t)==-1){
            res.push(t);
        }
    }
    return res;
} 


//header: {label:'ID', db_field:'primaryKeyId' }
export function tableHeaderClicked(header, reactComponent,  state_variable, callback ){
    
    if(typeof header != 'object'){
        console.error('wrong header specified for tableHeaderClicked()');
        return;
    }
    
    if(typeof state_variable == 'undefined'){
        state_variable = 'orderBy';
    }
    
    
    
    
    if(header.db_field!=undefined ){            
        var currentField = header.db_field
        var orderBy = {field:currentField, asc:false};

        if(reactComponent.state[state_variable].field == currentField){
            orderBy.asc = !reactComponent.state[state_variable].asc                
        }

        var state = {};
        state[state_variable] = orderBy;
        
        if(typeof callback == 'function'){
            
            reactComponent.setState(state, callback);
        }
        else{
            reactComponent.setState(state);
        }
        
    }

}


// export {obj2array};


export function humanFileSize(size) {
    if (size < 1) {
        return '0 B';
    }
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const fixed = (size / Math.pow(1024, i)).toFixed(2);
    return fixed + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
};

export function template(str, tokens) {
    return str.replace(/%([^%]+)%/g, (_, token) => tokens[token]);
}

export const isNull = (value) => {
    if (
        typeof value !== 'undefined'
        && value !== undefined
        && value != null
        && value != NaN
        && value
    ) {
        return false;
    }

    return true;
}

export function arrayLikeToArray(o) {
    const a = [];
    Object.keys(o).forEach(k => {
        a[k] = o[k];
    });
    return a;
}
